module.exports = __webpack_public_path__ + "img/trakcja.271eec75.png";